import { Button, required, SelectInput, useNotify, useRefresh } from "react-admin";
import { AttestationStatusChoices } from "utils/choices";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { studentRequests } from "api/studentApi";
import { Typography } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ManageAttestationsDialog = ({ attestationRecord }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const currentStatus = attestationRecord?.status;
  const currentStatusName = AttestationStatusChoices.find(c => c.id === currentStatus)?.name || currentStatus;

  const handleSubmit = async data => {
    const body = {
      attestationIds: [attestationRecord?.id],
      toStatus: data.toStatus,
    };
    await dataProvider.customRequest(studentRequests.updateAttestationsStatus(), body, "PUT");
    notify("Статусът беше променен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Смяна на статус"
      onConfirm={handleSubmit}
      defaultValues={{ toStatus: currentStatus }}
      triggerButton={
        <Button
          startIcon={<AutorenewIcon />}
          size="small"
          variant="contained"
          label="Статус"
        />
      }
    >
      <Typography>
        Текущ статус: <strong>{currentStatusName}</strong>
      </Typography>
      <SelectInput
        emptyText={false}
        source="toStatus"
        label="Нов статус"
        validate={required()}
        choices={AttestationStatusChoices}
      />
    </FormModal>
  );
};

export default ManageAttestationsDialog;
